export function iconFillVariant(icon: string) {
  if (icon.startsWith("ph:") && !icon.endsWith("-duotone"))
    return `${icon}-duotone`;

  return icon;
}
